module.exports = __webpack_public_path__ + "static/media/loseAutoSFX.10eb6bfd.mp3";